import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { isTouchEnabled } from 'helpers/generic';
import useStore from "store";
import Sidebar from 'layouts/Sidebar';
import Navbar from 'layouts/Navbar';
import NoticesNotifications from 'components/NoticesNotifications';
import ClosedFiscalYearBanner from 'components/ClosedFiscalYearBanner';

const Layout = styled.div`
	height: 100%;
	position: relative;

	@media screen and (min-width: 500px) {
		max-width: 1920px;
		margin: 0 auto;
	}
`;

const Main = styled.main`
	&:not(.is-mobile) {
		margin-left: 80px;

		&.sidebar-visible {
			margin-left: 250px;
		}
	}
	
	transition: all 0.3s;
	position: relative;	

	.page-title {
		--top: 49px;

		display: flex;
		background: var(--bs-blue);
		margin-top: var(--top);
		padding: 20px;
		border-bottom: 1px solid var(--bs-gray-300);
		align-items: center;
		position: sticky;
		top: var(--top);
		z-index: 3;

		h1 {
			display: flex;
			align-items: center;
			max-width: 1500px;

			color: white;
			font-size: 25px;
			line-height: 25px;
			margin: 0;
		}
	}

	.page-content {
		padding: 20px;
		/* max-width: 1500px; */
	}

	.card-footer {
		position: sticky;
		bottom: 0;
		background: #f7f7f7;
	}

	@media (max-width: 992px) {
    	& {
    		margin-left: 0 !important;
    	}
    }
`;

let axiosCancelToken = null;

export default function LoggedLayout(props) {
	const [sidebarTop, setSidebarTop] = useState(null);
	const [sidebarLeft, setSidebarLeft] = useState(null);

	const sidebarVisible = useStore(state => state.sidebarVisible);    

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();
	
		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);
    
	return (
		<Layout id="layout">
			<Navbar
				onSidebarTopChange={setSidebarTop}
				onSidebarLeftChange={setSidebarLeft}
			/>

			<Sidebar top={sidebarTop} left={sidebarLeft} />

			<Main className={(sidebarVisible ? 'sidebar-visible' : '') + ' ' + (isTouchEnabled() ? 'is-mobile' : '')}>
				{ props.children }
			</Main>

			<NoticesNotifications />

			<ClosedFiscalYearBanner />
		</Layout>
	);
}